import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { CustomFieldConstructorFactory } from './CustomField.factory'
import {
  CustomFieldValue,
  type CustomFieldValueConstructorData,
} from './CustomFieldValue'

export const CustomFieldValueConstructorFactory =
  Factory.Sync.makeFactory<CustomFieldValueConstructorData>({
    id: Factory.each(() => faker.random.number()),
    value: Factory.each(() => faker.random.word()),
    field: Factory.each(() => CustomFieldConstructorFactory.build()),
  })

export const CustomFieldValueFactory = EntityFactory(
  CustomFieldValue,
  CustomFieldValueConstructorFactory
)
